document.addEventListener('DOMContentLoaded', function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('.scroll-stack-scroller').forEach(function (scroller) {
    var inner = scroller.querySelector('.scroll-stack-inner');
    var cards = Array.prototype.slice.call(scroller.querySelectorAll('.scroll-stack-card'));
    if (!inner || !cards.length) return;

    if (prefersReducedMotion || typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      cards.forEach(function (card) {
        card.style.opacity = '1';
        card.style.transform = 'none';
      });
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    var count = cards.length;
    var MAX_STACK_DEPTH = 3;

    gsap.set(cards[0], { yPercent: 0, opacity: 1, scale: 1, zIndex: 1 });
    gsap.set(cards.slice(1), { yPercent: 100, opacity: 0, scale: 1 });

    ScrollTrigger.create({
      trigger: scroller,
      start: 'top top',
      end: function () {
        return '+=' + count * window.innerHeight * 0.8;
      },
      pin: inner,
      scrub: 0.5,
      onUpdate: function (self) {
        var progress = self.progress * count;

        cards.forEach(function (card, i) {
          var local = progress - i;
          var zIndex = i + 1;
          var isEntering = i > 0 && local < 1;

          if (i > 0 && local <= 0) {
            gsap.set(card, { yPercent: 100, opacity: 0, scale: 1, zIndex: zIndex });
          } else if (isEntering) {
            gsap.set(card, {
              yPercent: 100 * (1 - local),
              opacity: local,
              scale: 1,
              zIndex: zIndex,
            });
          } else {
            var depth = Math.min(Math.max(local - 1, 0), MAX_STACK_DEPTH);
            gsap.set(card, {
              yPercent: -depth * 3,
              opacity: 1,
              scale: 1 - depth * 0.045,
              zIndex: zIndex,
            });
          }
        });
      },
    });
  });
});
